import { ReactNode } from "react";

interface LabelValueProps {
  label: string;
  value: ReactNode;
  className?: string;
}

export default function LabelValue({
  label,
  value,
  className = "whitespace-nowrap",
}: LabelValueProps) {
  return (
    <>
      <span className={`font-bold text-black ${className}`}>{label}</span>
      <span className="text-black">{value}</span>
    </>
  );
}
